<template>
    <div class="d-flex justify-content-between mb-4 py-3">
        <div>
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/trainings'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                Edit Trainings
            </router-link>
        </div>
        <div class="d-flex justify-content-center">
            <button @click.prevent="EditTraining" class="styleBtnCss">Edit Training</button>
            &nbsp;&nbsp;
        </div>
    </div>

    <div id="createUserContainer" class="tabcontent1">
        <div class="row col-12">
            <div class="col-md-4">
                <label for="inputName" class="form-label">Name</label>
                <input type="text" autocomplete="off" @input="[changeHandler($event, errors, 'name'), setData($event,'name')]"
                       v-model="training.name" class="custom-input form-control" id="inputName" placeholder="Name">
                <div class="err" v-if="errors['name'].length > 0">
                    <div v-for="msg in errors['name']" class="text-danger">{{msg}}</div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="template_id1" class="form-label">Template to Use</label>
                <select id="template_id1" class="form-select" v-model="training.template_id">
                    <option value="null" disabled selected>Template to Use</option>
                    <option v-for="template in templates" :value="template.id">{{template.name}}</option>
                </select>
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <router-link to="/templates/create" style="color: #e65c00;">
                    <span style="color: #e65c00;">Add Template</span>
                </router-link>
            </div>
            <div class="col-md-3">
                <label for="training_type" class="form-label">Training Type</label>
                <select id="training_type" class="form-select" v-model="training.training_type">
                    <option value="null" disabled selected>Choose Training Type</option>
                    <option value="public">Public</option>
                    <option value="private">Private</option>
                </select>
            </div>
        </div>
    </div>

    <br>
    <br>

    <div id="createUserContainer2" class="tabcontent2">
        <div class="row col-12">
            <div class="col-md-6">
                <label for="inputName" class="form-label">Training Time</label>
                <div class="d-flex cssRangDates">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" @click="showRangeDates" value="1" v-model="training.date_type" :checked="training.date_type === 1">
                        <label class="form-check-label" for="flexRadioDefault1">
                            Range of Dates
                        </label>
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" @click="showSpecificDates" value="2" v-model="training.date_type" :checked="training.date_type === 2">
                        <label class="form-check-label" for="flexRadioDefault2">
                            Specific Date and Time
                        </label>
                    </div>
                </div>
            </div>

            <!-- specific dates -->

            <div v-if="isActivatedSpecific === true" class="col-md-12 pt-5 d-flex">
                <div class="col-md-4">
                    <h4>Select Date</h4>
                    <div>
                        <label>End Date</label>
                        <input type="date" autocomplete="off" class="form-control cssEndDate" v-model="training.end_date" :min="minToday">
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="allCssTime">
                        <div class="firstCssTime">
                            <h4>Select Time</h4>
                            <label>Start Time</label>
                            <input type="time" autocomplete="off" class="form-control styleFirstTime" v-model="training.start_time" @input="checkTimes1">
                        </div>
                        <div class="secondCssTime">
                            <label>End Time</label>
                            <input type="time" autocomplete="off" class="form-control styleSecondTime" v-model="training.end_time" @input="checkTimes2">
                        </div>
                    </div>
                </div>
            </div>

            <!-- range dates -->

            <div v-if="isActivatedRange === true" class="col-md-12 pt-5 d-flex">
                <div class="col-md-9">
                    <h4>Select Date</h4>
                    <div class="allCssDate">
                        <div class="firstDateStyle1">
                            <label>Start Date</label>
                            <input type="date" autocomplete="off" class="form-control cssFirstDateOne" v-model="training.start_date" @input="checkDates1" :min="minToday">
                        </div>
                        <div class="secondDateStyle2">
                            <label>End Date</label>
                            <input type="date" autocomplete="off" class="form-control cssSecondDateTwo" v-model="training.end_date" @input="checkDates2" :min="minToday">
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <h4>Select Duration</h4>
                    <div class="cssDuration">
                        <label>Duration</label>
                        <input type="text" autocomplete="off" class="form-control styleFirstTime" v-model="training.duration">
                    </div>
                </div>
            </div>

        </div>
    </div>

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";
    import changeHandler from "../../../validation/userValidation";
    import {computed} from "vue";
    import training from "../../../api-services/training";
    import repository from "../../../api-services/repository";

    export default {
        name: 'edit-training',
        components:{
            ConfirmationModal,
            AlartModal
        },
        data(){
            return{
                changeHandler,
                isActivatedRange:false,
                isActivatedSpecific:false,
                ImagePath:'',
                templates:[],
                minToday:'2022/01/01',
                firstTimeInDay:'00:00:00',
                lastTimeInDay:'23:59:59',
                training: {
                    name:null,
                    type:2,
                    participant_type:null,
                    training_type:null,
                    date_type:null,
                    start_date:null,
                    end_date:null,
                    duration:null
                },
                errors:{
                    name:[],
                    type:[],
                    participant_type:[],
                    date_type:[],
                    start_date:[],
                    end_date:[],
                    duration:[],
                    isError: false
                },
                showModal:false,
                message:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                    user_email: false,
                    host:false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },

        async mounted(){
            await this.$store.dispatch('activeTap', 'training');
            this.getTraining();
            this.getTemplate();

            let today = new Date().toISOString().split('T')[0];
            this.minToday = today;
        },
        methods:{
            checkTimes1(e){
                console.log(e);
                if(e.target.value > this.training.end_time){
                    this.training.end_time = null;
                }
            },
            checkTimes2(e){
                if(e.target.value < this.training.start_time){
                    this.training.start_time = null;
                }
            },
            checkDates1(e){
                if(e.target.value > this.training.end_date){
                    this.training.end_date = null;
                }
            },
            checkDates2(e){
                if(e.target.value < this.training.start_date){
                    this.training.start_date = null;
                }
            },
            async getTemplate(){
                try{
                    const response = await repository.index('templates');
                    this.templates = response.data.data.data;
                }catch(e){
                    console.log(e);
                }
            },
            async getTraining(){
                try{
                    const training_id = this.$route.params.id;
                    const response = await training.show(training_id);

                    this.training.name = response.data.data.name;
                    this.training.template_id = response.data.data.template.id;
                    this.training.date_type = response.data.data.date_type;
                    this.training.start_date = response.data.data.start_date;
                    this.training.end_date = response.data.data.end_date;
                    this.training.start_time = response.data.data.start_time;
                    this.training.end_time = response.data.data.end_time;
                    this.training.duration = response.data.data.duration;
                    this.training.training_type = response.data.data.training_type;

                    console.log(response);
                    if(response.data.data.date_type === "1"){
                        this.isActivatedRange = true;
                        this.isActivatedSpecific = false;
                    }else{
                        this.isActivatedRange = false;
                        this.isActivatedSpecific = true;
                    }

                }catch(e){
                    console.log(e);
                }
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'name') {
                    if (val !== '') {
                        this.isData.name = true;
                    } else {
                        this.isData.name = false;
                    }
                }

                if (type === 'user_email') {
                    if (val !== '') {
                        this.isData.user_email = true;
                    } else {
                        this.isData.user_email = false;
                    }
                }

                if (type === 'host') {
                    if (val !== '') {
                        this.isData.host = true;
                    } else {
                        this.isData.host = false;
                    }
                }
                if (this.isData.name || this.isData.user_email || this.isData.host) {
                    this.$store.dispatch('setDataFlag', true);
                    console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    console.log('no data ==>> ');
                }

            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/competitions');
                }
            },
            async EditTraining(){
                try{
                    const training_id = this.$route.params.id;
                    if(this.training.name === null || this.training.template_id === null || this.training.end_date === null || this.training.training_type === null){
                        this.showModal = true;
                        this.ImagePath = 'close.png';
                        this.message = 'Please Fill Data Correctly';
                    }else{
                        if(this.training.date_type === "1"){
                            if(this.training.start_date === null || this.training.duration === null || this.training.duration === ''){
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Please Fill Data Correctly';
                            }else{
                                this.training.start_time = null;
                                this.training.end_time = null;

                                await training.update(training_id , {
                                    name:this.training.name,
                                    type:this.training.type,
                                    training_type:this.training.training_type,
                                    template_id:this.training.template_id,
                                    date_type:this.training.date_type,
                                    start_date:this.training.start_date,
                                    end_date:this.training.end_date,
                                    start_time:this.firstTimeInDay,
                                    end_time:this.lastTimeInDay,
                                    duration:this.training.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-edit-trainings/'+training_id});
                            }
                        }else{
                            if(this.training.start_time === null || this.training.end_time === null){
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Please Fill Data Correctly';
                            }else{
                                this.training.start_date = null;
                                this.training.duration = null;

                                await training.update(training_id , {
                                    name:this.training.name,
                                    type:this.training.type,
                                    training_type:this.training.training_type,
                                    template_id:this.training.template_id,
                                    date_type:this.training.date_type,
                                    start_date:this.minToday,
                                    end_date:this.training.end_date,
                                    start_time:this.training.start_time,
                                    end_time:this.training.end_time,
                                    duration:this.training.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-edit-trainings/'+training_id});
                            }
                        }
                    }
                }catch(e){
                    console.log(e);
                }
            },
            showRangeDates(){
                this.isActivatedRange = true;
                this.isActivatedSpecific = false;
            },
            showSpecificDates(){
                this.isActivatedRange = false;
                this.isActivatedSpecific = true;
            }
        }
    }
</script>

<style scoped>
    ::-webkit-calendar-picker-indicator {
        filter: invert(100%);
    }

    .cssFirstDateOne{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssSecondDateTwo{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .allCssTime{
        display: flex;
        flex-wrap: wrap;
        justify-content: end;
        align-items: end;
        gap:50px;
    }

    .allCssDate{
        display: flex;
        flex-wrap: wrap;
        gap:50px;
    }

    .styleSecondTime{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .styleFirstTime{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssEndDate{
        background-color: #021A24;
        color: #fff;
        width:350px;
        padding: 10px;
    }
    .cssRangDates{
        border: 1px solid #04354a;
        padding: 10px;
        width:360px;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: none !important;
        border: 2px solid #032a3a !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .form-check-input:focus {
        box-shadow: 0 0 0 1px #e95626 !important;
    }
    #training_type{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    #template_id1{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    .custom-input{
        background-color: #032A3A;
        color: #fff;
        padding: 10px;
    }
    .styleBtnCss2{
        width: 180px;
        background-color: transparent;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: 2px solid #fff;
    }
    .styleBtnCss{
        width: 180px;
        background-color: #E95626;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }
    .tabcontent2{
        display: block;
        padding: 30px;
        height: 30vh;
        border-top: none;
        background-color: #032A3A;
        border-radius: 15px;
    }
    .tabcontent1{
        display: block;
        padding: 30px;
        height: 20vh;
        border-top: none;
        background-color: #032A3A;
        border-radius: 15px;
    }
</style>